<div *ngIf="loading" class="schedule-state schedule-loading" role="status" aria-live="polite">
  <span class="schedule-loading-indicator" aria-hidden="true"></span>
  <span>Buscando horários disponíveis...</span>
</div>

<div *ngIf="hasHourAvailable && !loading && firstAvailableLabel as firstAvailable" class="next-available-summary" role="status">
  <mat-icon aria-hidden="true">event_available</mat-icon>
  <span>Próximo horário mostrado: <strong>{{ firstAvailable }}</strong></span>
</div>

<div class="schedule-grid-wrapper">
  <ng-container *ngIf="hasHourAvailable && !loading">
    <button type="button" [disabled]="!canGoToPreviousWeek" aria-label="Semana anterior" class="arrow left" (click)="goToPreviousWeek()">&#9664;</button>

    <div
      class="schedule-grid"
      [ngClass]="{
        'animating-left': animationDirection === 'left',
        'animating-right': animationDirection === 'right'
      }"
    >
      <div class="day-column" *ngFor="let date of dates; trackBy: trackByDate">
        <div class="day-header">
          <div>{{ date.day }}</div>
          <div>{{ date.date }}</div>
        </div>

        <!-- POR ORDEM DE CHEGADA -->
        <ng-container *ngIf="isByOrder">
          <ng-container *ngIf="availability[date.fullDate]?.length">
            <div *ngFor="let range of availability[date.fullDate]; trackBy: trackByRange" class="hour-cell">
              <button
                mat-stroked-button
                color="primary"
              type="button"
                class="bt-horario big"
                [attr.aria-label]="'Agendar ' + date.day + ', ' + date.date + ' no período ' + range"
                *ngIf="isAvailableByOrder(date.fullDate, range)"
                [ngClass]="{ selected: isSelectedByOrder(date.fullDate, range) }"
                (click)="selectHourByOrder(date.fullDate, range)"
              >
                {{ range }}
              </button>
            </div>
          </ng-container>
        </ng-container>

        <!-- POR HORÁRIO FIXO -->
        <ng-container *ngIf="!isByOrder">
          <div *ngFor="let hour of getDisplayedHours(date.fullDate); trackBy: trackByHour" class="hour-cell">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="bt-horario big hour-btn available"
              [attr.aria-label]="'Agendar ' + date.day + ', ' + date.date + ' às ' + hour"
              *ngIf="isAvailable(date.fullDate, hour)"
              [ngClass]="{ selected: isSelected(date.fullDate, hour) }"
              (click)="selectHour(date.fullDate, hour)"
            >
              {{ hour }}
            </button>
            <button type="button" mat-flat-button color="secondary" *ngIf="!isAvailable(date.fullDate, hour)" class="bt-horario hour-btn unavailable" disabled>
              {{ hour }}
            </button>
          </div>
        </ng-container>

        <!-- CASO NÃO HAJA HORÁRIOS -->
        <div class="hour-cell" *ngIf="!availability[date.fullDate]?.length">
          <button mat-flat-button color="secondary" class="hour-btn bt-horario big unavailable" disabled>--</button>
        </div>
      </div>
    </div>

    <button type="button" class="arrow right" aria-label="Próxima semana" (click)="goToNextWeek()">&#9654;</button>
  </ng-container>
  <div *ngIf="!hasHourAvailable && !loading" class="schedule-state schedule-empty-state" role="status">
    <mat-icon aria-hidden="true">event_busy</mat-icon>
    <span>{{ hoursLoadMessage || 'Sem horários disponíveis no momento. Tente outra data ou procedimento.' }}</span>
    <button *ngIf="canRetryHoursLoad" mat-stroked-button color="primary" type="button" (click)="getPractitionerHours()">
      Tentar novamente
    </button>
  </div>
</div>

<div *ngIf="!loading && hasHourAvailable && !hasAvailableTimeInVisibleDates" class="schedule-state schedule-empty-state" role="status">
  <mat-icon aria-hidden="true">event_busy</mat-icon>
  <span>Não há horários livres entre as datas exibidas. Use as setas para consultar outras datas.</span>
</div>

<div class="expand-all-toggle" *ngIf="hasMoreThanFiveSlots() && !isByOrder">
  <button class="toggle-btn" (click)="toggleExpandAll()">
    {{ expanded ? 'Ver menos' : 'Ver mais horários' }}
  </button>
</div>
